import { useRef, useState } from "react";
import { performTrackedSignOut } from "@softmax/web-features/telemetry/analytics";
import {
  analyticsEvents,
  analyticsSources,
} from "@softmax/web-features/telemetry/events";

export function useAccountSignOut() {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string>();
  const inFlight = useRef(false);

  return {
    pending,
    error,
    onSignOut() {
      if (inFlight.current) return;

      inFlight.current = true;
      setPending(true);
      setError(undefined);
      void performTrackedSignOut({
        event: analyticsEvents.accountPageSignOutClicked,
        properties: { source: analyticsSources.accountPage },
      })
        .then(undefined, (failure: Error) => {
          setError(`Sign out failed: ${failure.message}`);
        })
        .finally(() => {
          inFlight.current = false;
          setPending(false);
        });
    },
  };
}
